<script setup lang="ts">
import { UIButton } from '@groover-dev/groover-ui'

import { useGrooverPlusSubscribeCta } from '~/composables/useGrooverPlusSubscribeCta'

import type { GrooverPlusSubscribeCtaFragment } from '~/graphql/generated'

type Props = GrooverPlusSubscribeCtaFragment

withDefaults(defineProps<Props>(), {
  text: '',
})

const { createStripeCheckoutSession } = useGrooverPlusSubscribeCta()
</script>

<template>
  <UIButton
    :text
    variant="primary"
    color="accent"
    size="large"
    @click="createStripeCheckoutSession"
  />
</template>
